import { ThemeEvents, CartUpdateEvent } from '@theme/events';

document.addEventListener("DOMContentLoaded", (event) => {

  const CONTAINER = document.querySelector('.variant_with_qty_container');
  if (!CONTAINER) return;



document.addEventListener('click', (e) => {
  const btn = e.target.closest('.read-more, .read-more-tab');
  if (!btn) return;
  e.preventDefault();

  const wrap = btn.closest('.product-date-container, .pd-tab-container, body');
  const limited = wrap.querySelector('.limited-text');
  const expanded = wrap.querySelector('.expanded-text');
  if (!limited || !expanded) return;

  const open = expanded.classList.toggle('hidden') === false; // now visible
  limited.classList.toggle('hidden', open);

  btn.textContent = open ? 'Read Less' : 'Read More';
  btn.setAttribute('aria-expanded', String(open));
});

  const ADD_BTN = document.getElementById('variant_with_qty_btn');
  const SPINNER = ADD_BTN?.querySelector('.loading-overlay__spinner');
  const BTN_TEXT = ADD_BTN?.querySelector('#product-add-to-cart-btn-text');

  // Helpers
  const clampInt = (v) => Math.max(0, Number.isFinite(+v) ? Math.floor(+v) : 0);

  function getAllInputs() {
    return Array.from(CONTAINER.querySelectorAll('.variant__quantity__input'));
  }

  function anyQtySelected() {
    return getAllInputs().some(i => clampInt(i.value) > 0);
  }

  function updateAddButtonState() {
    if (!ADD_BTN) return;
    ADD_BTN.disabled = !anyQtySelected();
  }

  function syncInput(input, nextVal) {
    const val = clampInt(nextVal);
    if (input.value != val) input.value = val;
    updateAddButtonState();
  }

  // Plus / Minus controls
  CONTAINER.addEventListener('click', (e) => {
    const btn = e.target.closest('.quantity__button');
    if (!btn) return;

    const wrap = btn.closest('quantity-input');
    const input = wrap?.querySelector('.variant__quantity__input');
    if (!input) return;

    const cur = clampInt(input.value);
    if (btn.name === 'plus') syncInput(input, cur + 1);
    if (btn.name === 'minus') syncInput(input, cur - 1);
  });

  // Manual typing
  CONTAINER.addEventListener('input', (e) => {
    const input = e.target.closest('.variant__quantity__input');
    if (!input) return;
    // Do not clamp while typing non-integer; wait until blur/change
    updateAddButtonState();
  });

  CONTAINER.addEventListener('change', (e) => {
    const input = e.target.closest('.variant__quantity__input');
    if (!input) return;
    syncInput(input, input.value);
  });

  // Build items payload
  function buildItemsPayload() {
    const inputs = getAllInputs();
    const items = [];

    inputs.forEach(input => {
      const qty = clampInt(input.value);
      if (qty <= 0) return;
      const id = input.dataset.variant_id;
      const sellingPlan = (input.dataset.variant_selling_plan || '').trim();
      if (!id) return;

      const item = { id: Number(id), quantity: qty };
      if (sellingPlan) item.selling_plan = Number(sellingPlan);
      items.push(item);
    });

    return items;
  }

  // AJAX add
async function addToCart(items) {
  const res = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ items })
  });

  const data = await res.json().catch(() => null);
  if (!res.ok) throw new Error(data?.description || 'Add to cart failed');

  // Option A: plain CustomEvent
//   document.dispatchEvent(new CustomEvent('cart:updated', {
//     detail: {
//       action: 'add',
//       source: 'product-form',
//       productId: data?.items?.[0]?.product_id,
//       variantId: data?.items?.[0]?.id,
//       itemCount: data?.item_count,
//       cart: data
//     }
//   }));

    document.dispatchEvent(
      new CartUpdateEvent(data, 'add-to-cart-btn', {
        source: 'product-form',
        productId: data.items[0].product_id, 
        variantId: data.items[0].id,        
        itemCount: data.item_count,        
      })
    );

  return data;
}


  // Button handler
  ADD_BTN?.addEventListener('click', async () => {
    const items = buildItemsPayload();
    if (items.length === 0) return;

    // UX: lock button
    const prevText = BTN_TEXT ? BTN_TEXT.textContent : '';
    ADD_BTN.disabled = true;
    SPINNER?.classList.remove('hidden');
    if (BTN_TEXT) BTN_TEXT.textContent = 'Adding…';

    try {
      const cart = await addToCart(items);

      // Optional: dispatch event for themes/drawers to hook into
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));

      // Optional: reset zeros except keep user intent; here we keep values
      // If you want to clear, uncomment:
      // getAllInputs().forEach(i => syncInput(i, 0));

    } catch (err) {
      console.error(err);
      // Optional: show error UI
      alert(err.message);
    } finally {
      SPINNER?.classList.add('hidden');
      if (BTN_TEXT) BTN_TEXT.textContent = prevText || 'Add To Basket';
      updateAddButtonState();
    }
  });

  // Initial state
  updateAddButtonState();
})


